import HostVideoCtrl from './HostVideoCtrl';

export default HostVideoCtrl;
export * from './HostVideoCtrl.type';
